// ServDevelopData.js
export const ServDevelopTopImg = [
  {
    id: 0,
    image: require('../images/ServiceImg/ServDevelop-00.jpg'),
    alt: 'ServiceImg/ServDevelop-00.jpg',
    link: '',
  },
  {
    id: 1,
    image: require('../images/ServiceImg/ServDevelop-01.jpg'),
    alt: 'ServiceImg/ServDevelop-01.jpg',
    link: '',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/ServDevelop-02.jpg'),
    alt: 'ServiceImg/ServDevelop-02.jpg',
    link: '',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/ServDevelop-03.jpg'),
    alt: 'ServiceImg/ServDevelop-03.jpg',
    link: '',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/ServDevelop-04.jpg'),
    alt: 'ServiceImg/ServDevelop-04.jpg',
    link: '',
    // link: 'https://xxxxxx.com/design/xxxxxx',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/ServDevelop-05.jpg'),
    alt: 'ServiceImg/ServDevelop-05.jpg',
    link: '',
    // link: 'https://xxxxxx.com/design/xxxxxx',
  },

]

export const ServDevelopTop = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelopXxxxxx.png'),
    // alt: 'ServiceImg/ServDevelopXxxxxx.png',
    name: 'P-Cap Touch Panel Manufacturing',
    title: '投射電容觸控面板(P-Cap Touch Panel)製造',
    subtitle: '適用於觸控面板生產與製造解決方案',
    text:
      '\n' +
      '\n' +
      '\n',
    nameEng: 'P-Cap Touch Panel Manufacturing',
    titleEng: 'P-Cap Touch Panel Manufacturing',
    subtitleEng: 'A touch panel production and manufacturing solutions',
    textEng:
      '\n' +
      '\n' +
      '\n',
    describe: 'ServDevelopTop',
    link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/13',
  },
]

export const ServDevelopProduce = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Touch Panel Manufacturing',
    title: '觸控面板製造',
    subtitle: '觸控面板生產要素',
    text:
      '     ＊ 生產流程：以品質穩定為最高要求下，不斷改善流程達到提升良率與產能提升\n' +
      '     ＊ 生產設備：依照生產流程選擇適當的生產設備，以縮減工時、提升良率、效率與品質\n' +
      '     ＊ 基材選擇：選擇合乎規範、尺寸、品質與價格合適的基材\n' +
      '     ＊ 設計與開發：開發遵守EVT、DVT、PR、MP 4階段\n' +
      '     ＊ 無塵的環境：印刷與貼合無塵等級100~1000級，檢驗、加工、測試等要求達到10K~100K\n' +
      '     ＊ 生產作業指導書(SOP)、工作指令(Working Instruction)等全面完整，並嚴格遵守\n' +
      '     ＊ 6S：整理(Seiri)、整頓(Seiton)、清掃(Seiso)、清潔(Seiketsu)、素養(Shitsuke)、安全(Safety)\n' +
      '     ＊ 品質體系：QC、QA、QE\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: 'Touch Panel Manufacturing',
    subtitleEng: 'Key Factors',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDevelopProduce',
    link: '',
    time: '2025/2/17',
  },
  {
    id: 1,
    name: 'Touch Panel Manufacturing',
    title: '觸控面板製造',
    subtitle: '觸控面板製造',
    text:
      '  1.  從原料到最終產品，我們將探索創建電容式觸控螢幕的每個步驟。\n' +
      '       這包括用於生產具有透明電極和各種塗層的靈敏且耐用的電容式觸控面板的複雜技術。\n' +
      '       透過深入了解這項製造奇蹟，您將欣賞到每台設備的獨創性和精確性。\n' +
      '       因此，請準備好揭開觸控螢幕製造的秘密，我們將帶您從頭到尾經歷這段迷人的旅程。\n' +
      '       讓我們開始探索這一尖端工藝，看看液晶顯示面板如何徹底改變我們的數位世界。\n' +
      '\n' +
      '  2.  消費產品、手機平板、機器設備、交通工具等的輸入系統在技術上複雜且精密。\n' +
      '       然而，應用要求和技術不斷發展。對於 P-Cap Touch Panel 設計，有各種組件可供組裝和整合。\n' +
      '       蓋板、P-Cap Sensor、顯示器、光學黏合技術、機械整合以及特定應用解決方案的選擇起著重要作用。\n' +
      '       透過正確選擇這些組件，可以開發出與應用程式最佳匹配的輸入系統。\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: '',
    link: 'https://touchinternational.com/applications/#top',
    time: '2025/2/20',
  },
]

export const ServDevelopProcFlow = [
  {
    id: 1,
    image: require('../images/ServiceImg/ProcFlowSensor.jpg'),
    alt: 'ServiceImg/ProcFlowSensor.jpg',
    // image: require('../images/ServiceImg/SensorProcFlow.png'),
    // alt: 'ServiceImg/SensorProcFlow.png',
    name: 'Touch Panel Sensor Process Flow',
    title: 'P-Cap Sensor Process Flow',
    subtitle: 'Dito Sensor Process Flow',
    text:
      '     ＊ 功能片生產流程：\n' +
      '          • 來料外觀及功能檢驗\n' +
      '          • 印刷正反面蝕刻油墨\n' +
      '          • 蝕刻烘烤清洗、檢驗\n' +
      '          • 印刷正反面銀漿線、烘烤\n' +
      '          • 印刷正反面保護膜、烘烤\n' +
      '          • 正反面銀線雷射雕刻\n' +
      '          • 印刷正反面銀線絕緣保護\n' +
      '          • 外形切割、裂片成形\n' +
      '          • 假壓電測、熱壓FPC\n' +
      '          • 電氣測試、外觀檢驗\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDevelopSensorProcFlow',
    link: '',
    time: '2025/2/20',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/ProcFlowTPM.jpg'),
    alt: 'ServiceImg/ProcFlowTPM.jpg',
    // image: require('../images/ServiceImg/TPMProcFlow.png'),
    // alt: 'ServiceImg/TPMProcFlow.png',
    name: 'Touch Panel Process Flow',
    title: 'P-Cap Touch 生產流程',
    subtitle: 'P-Cap Touch Panel 生產流程',
    text:
      '     ＊ P-Cap Touch生產流程：\n' +
      '          • 來料外觀檢驗\n' +
      '          • 假壓電測\n' +
      '          • FPC熱壓、Bonding電測\n' +
      '          • 功能片貼附OCA\n' +
      '          • 蓋板烘烤、真空貼合、壓合\n' +
      '          • 貼合脫泡、外觀氣泡檢、UV固化\n' +
      '          • 外觀檢驗、電氣功能測試\n' +
      '          • 貼防爆膜\n' +
      '          • 貼保護膜、背膠加工\n' +
      '          • FQC外觀檢驗、FQC電氣功能測試\n' +
      '          • OQC電氣功能、外觀檢批退\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDevelopTouchProcFlow',
    link: '',
    time: '2025/2/20',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/TDMProcFlow.png'),
    alt: 'ServiceImg/TDMProcFlow.png',
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Touch Display Process Flow',
    title: 'Touch Display Process Flow',
    subtitle: 'Touch Display Process Flow',
    text:
      '     ＊ TP+LCM全貼合生產流程：\n' +
      '          • \n' +
      '          • \n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDevelopTouchDislayProcFlow',
    link: '',
    time: '2025/2/20',
  },
]

export const ServDevelopSensorEquip = [
  {
    id: 0,
    // image: require('../images/ServEquipImg/touchCtrl-1.png'),
    // alt: 'ServEquipImg/touchCtrl-1.png',
    name: 'Production Equipment',
    title: '生產設備',
    subtitle: '功能片生產設備、',
    text:
      '     ＊ 功能片生產設備\n' +
      '          • 網版印刷機' +
      '          • 蝕刻清洗機' +
      '          • UV固化機' +
      '          • 無塵烤箱\n' +
      '          • 雷射雕刻機' +
      '          • 玻璃切刻機' +
      '          • FPC熱壓機' +
      '          • 電氣功能測試設備\n' +
      '\n',
    describe: '生產設備',
  },
  {
    id: 1,
    image: require('../images/ServiceImg/ServSensorEquip-01.jpg'),
    alt: 'ServiceImg/ServSensorEquip-01.jpg',
    name: 'Mesh Printing Machine',
    title: '網版印刷機',
    text: '網版印刷機:功能說明及使用製程',
    describe: '網版印刷機',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/ServSensorEquip-02.jpg'),
    alt: 'ServiceImg/ServSensorEquip-02.jpg',
    name: 'Etching & Clean Line',
    title: '蝕刻清洗線線',
    text: '蝕刻清洗線:功能說明及使用製程',
    describe: '蝕刻清洗線線',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/ServSensorEquip-03.jpg'),
    alt: 'ServiceImg/ServSensorEquip-03.jpg',
    name: 'UV Light Curing Machine',
    title: 'UV固化機',
    text: 'UV固化機:功能說明及使用製程',
    describe: 'UV固化機',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/ServSensorEquip-04.jpg'),
    alt: 'ServiceImg/ServSensorEquip-04.jpg',
    name: 'Clean Room Oven',
    title: '無塵烤箱',
    text: '無塵烤箱:功能說明及使用製程',
    describe: '無塵烤箱',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/ServSensorEquip-05.jpg'),
    alt: 'ServiceImg/ServSensorEquip-05.jpg',
    name: 'Laser Engraving Machine',
    title: '雷射雕刻機',
    text: '雷射雕刻機:功能說明及使用製程',
    describe: '雷射雕刻機',
  },
  {
    id: 6,
    image: require('../images/ServiceImg/ServSensorEquip-06.jpg'),
    alt: 'ServiceImg/ServSensorEquip-06.jpg',
    name: 'Glass Cutting Machine',
    title: '玻璃切刻機',
    text: '玻璃切刻機:功能說明及使用製程',
    describe: '玻璃切刻機',
  },
  {
    id: 7,
    image: require('../images/ServiceImg/ServSensorEquip-07.jpg'),
    alt: 'ServiceImg/ServSensorEquip-07.jpg',
    name: 'FPC Bonding Machine',
    title: 'FPC熱壓機',
    text: 'FPC熱壓機:功能說明及使用製程',
    describe: 'FPC熱壓機',
  },
  {
    id: 8,
    image: require('../images/ServiceImg/ServSensorEquip-08.jpg'),
    alt: 'ServiceImg/ServSensorEquip-08.jpg',
    name: 'Functional test equipment',
    title: '電氣功能測試設備',
    text: '電氣功能測試設備:功能說明及使用製程',
    describe: '電氣功能測試設備',
  },
  {
    id: 9,
    image: require('../images/ServiceImg/ServSensorEquip-09.jpg'),
    alt: 'ServiceImg/ServSensorEquip-09.jpg',
    name: 'UV Light Curing Machine',
    title: 'UV固化機',
    text: 'UV固化機:功能說明及使用製程',
    describe: 'UV固化機',
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'ServiceImg/ServDevelopXxxxxxxxxx.png',
    subtitle: '',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    link: '',
    time: '2025/2/20',
  },
]

export const ServDevelopTPMEquip = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Production Equipment',
    title: '生產設備',
    subtitle: 'P-Cap Touch 生產設備',
    text:
      '     ＊ 投射電容觸控面板生產設備：\n' +
      '          • OCA翻板貼合機\n' +
      '          • FPC熱壓機\n' +
      '          • 真空壓合機\n' +
      '          • 貼合脫泡機\n' +
      '          • UV固化機\n' +
      '          • 無塵烤箱\n' +
      '          • 保護膜貼合機\n' +
      '          • 電氣功能測試設備\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: '',
    link: '',
    time: '2025/2/20',
  },
]

export const ServDevelopTDMEquip = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Production Equipment',
    title: '生產設備',
    subtitle: 'Touch Display 生產設備',
    text:
      '     ＊ TP+LCM全貼合生產設備：\n' +
      '          • 真空壓合機\n' +
      '          • 貼合脫泡機\n' +
      '          • UV固化機\n' +
      '          • 無塵烤箱\n' +
      '          • 保護膜貼合機\n' +
      '          • 電氣功能測試設備\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: '',
    link: '',
    time: '2025/2/20',
  },
]

export const ServDevelopProdArea = [
  {
    id: 1,
    image: require('../images/ServiceImg/ServPreProdLine-01.png'),
    alt: 'ServiceImg/PrePreProdLine-01.png',
    name: 'Pre-Production Line',
    title: '前段生產線',
    subtitle: '前段生產線',
    text:
      '     • 印刷生產線：無塵等級100~1000，穿著無塵衣\n' +
      '     • 蝕刻清洗生產線：無塵等級1000~10000，穿著無塵衣\n' +
      '     • 無塵烤箱區：無塵等級1000~10000，穿著無塵衣\n' +
      '     • 雷射雕刻房\n' +
      '     • 外觀檢驗、功能測試區\n' +
      '     • 線邊原料倉、成品倉\n' +
      '     • 成品倉\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: 'Pre-Production Line',
    textEng:
      '\n' +
      '\n',
    describe: 'ServDevelopProduce',
    link: '',
    time: '2025/3/6',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/ServPostProdLine-01.png'),
    alt: 'ServiceImg/ServPostProdLine-01.png',
    name: 'Post-Production Line',
    title: '後段生產線',
    subtitle: '後段生產線',
    text:
    '     • 貼合生產線：無塵等級100~1000，穿著無塵衣\n' +
    '     • 熱壓生產線：無塵等級1000~10000，穿著無塵衣\n' +
    '     • 玻璃切割間：無塵等級1000~10000\n' +
    '     • 雷射雕刻績房\n' +
    '     • 外觀檢驗、功能測試區\n' +
    '     • 線邊原料成品線邊倉\n' +
    '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: '',
    link: '',
    time: '2025/3/6',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/ServAssistWorkArea-01.png'),
    alt: 'ServiceImg/ServAssistWorkArea-01.png',
    name: 'Assist Working Area',
    title: '其他空間',
    subtitle: '其他空間',
    text:
      '     • 加工區：\n' +
      '     • 原料倉\n' +
      '     • 成品倉\n' +
      '     • 辦公室\n' +
      '\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: '',
    link: '',
    time: '2025/3/6',
  },
]
